import {
  Button,
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
import { useMutation } from "@tanstack/react-query";
import { useFormik } from "formik";
import { toast } from "react-toastify";

import { Input } from "./Input";
import Loading from "./Loading";
import { CategoryCreate } from "../services/payable";

const CategoryRegister = ({
  open,
  onClose,
  refetch,
}: {
  open: boolean;
  onClose: () => void;
  refetch: () => void;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: CategoryCreate,
    onSuccess: () => {
      toast.success("Categoria cadastrada com sucesso!");
      refetch?.();
      onClose();
    },
    onError: (e: any) => {
      const message =
        e?.response?.data?.message ??
        e?.message ??
        "Erro ao cadastrar a categoria!";
      toast.error(message);
    },
  });

  const { values, handleChange, handleSubmit } = useFormik({
    initialValues: { name: "" },
    onSubmit: ({ name }) => {
      const payload = { name: name.trim() };
      if (!payload.name) {
        toast.warn("Informe o nome da categoria.");
        return;
      }
      mutate(payload);
    },
  });

  return (
    <Dialog maxWidth="xs" open={open} onClose={onClose}>
      <Loading loading={isPending} />
      <DialogContent
        sx={{ backgroundColor: "secondary.main" }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            handleSubmit();
          }
        }}
      >
        <Grid2 container spacing={2} padding={1}>
          <Grid2 size={{ xs: 10 }}>
            <Typography fontSize={24} fontWeight={600}>
              Cadastrar Categoria
            </Typography>
            <Typography variant="subtitle1" color="secondary.contrastText">
              Informe o nome da categoria
            </Typography>
          </Grid2>

          <Grid2 size={{ xs: 2 }}>
            <IconButton onClick={onClose} aria-label="Fechar">
              <IconX />
            </IconButton>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <Stack>
              <Input
                id="name"
                name="name"
                label="Nome da categoria"
                placeholder="Ex.: Despesas Fixas"
                value={values.name}
                onChange={handleChange}
                autoFocus
              />
            </Stack>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <Button
              fullWidth
              variant="contained"
              disabled={!values.name.trim() || isPending}
              onClick={() => handleSubmit()}
            >
              Cadastrar
            </Button>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

export default CategoryRegister;
